// SYSTEM_APIS
const SINGUP_API =
  "https://marketing.thewinnerindia.com/apis/register/signup.php";
const SINGIN_API =
  "https://marketing.thewinnerindia.com/apis/register/signin.php";
const CRUD_API_EDITPROFILE =
  "https://marketing.thewinnerindia.com/apis/users/Edit_profile.php";

const FETCH_Users =
  "https://marketing.thewinnerindia.com/apis/users/Fetch_userDetails.php";

const user_referral_level_one =
  "https://marketing.thewinnerindia.com/apis/users/user_referral_level_one.php";

const USER_CURRENCY =
  "https://marketing.thewinnerindia.com/apis/USER_CURRENCY.php";
const USER_WITHDRAWAL =
  "https://marketing.thewinnerindia.com/apis/Payments/request_withdrawal.php";
const CRUD_Withdrawal =
  "https://marketing.thewinnerindia.com/apis/Payments/CRUD_Withdrawal.php";
const Contactus =
  "https://marketing.thewinnerindia.com/apis/Help/Contactus.php";
const GetPreviousMessages =
  "https://marketing.thewinnerindia.com/apis/Help/GetPreviousMessages.php";

const SettingsCRUD =
  "https://marketing.thewinnerindia.com/apis/Settings_CRUD.php";
const Pannel_Payments =
  "https://marketing.thewinnerindia.com/apis/Payments/Pannel_Payments.php";

/*Admin Apis*/
const ADMIN_USER_TREE =
  "https://marketing.thewinnerindia.com/apis/admin_apis/admin_referral_tree.php";
const CRUDadmin =
  "https://marketing.thewinnerindia.com/apis/admin_apis/CRUDadmin.php";
const FetchMedia = "https://marketing.thewinnerindia.com/apis/assets/media.php";

const AdminMessages =
  "https://marketing.thewinnerindia.com/apis/admin_apis/AdminMessages.php";
const CRUDPayments =
  "https://marketing.thewinnerindia.com/apis/admin_apis/CRUDPayments.php";
  const Add_BONUSE= "https://marketing.thewinnerindia.com/apis/admin_apis/added_bonus.php";

export const API_KEY = "7f5aaac6061648cc5030d880acddca1f";

export {
  // SYSTEM_APIS
  SINGUP_API,Add_BONUSE,
  AdminMessages,
  SINGIN_API,
  CRUD_API_EDITPROFILE,
  USER_CURRENCY,
  FETCH_Users,
  ADMIN_USER_TREE,
  FetchMedia,
  Contactus,
  GetPreviousMessages,
  SettingsCRUD,
  Pannel_Payments,
  CRUDPayments,
  user_referral_level_one,
  USER_WITHDRAWAL,
  CRUD_Withdrawal,
  CRUDadmin,
};
